import React, { useEffect, useRef, useState } from 'react';
import {
  Image,
  Animated,
  StyleSheet,
  ScrollView,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
} from 'react-native';
import * as Haptics from 'expo-haptics';
import LoginForm from '../../components/loginForm';
import SignUpForm from '../../components/signUpForm';
import CookiePopUp from '../../components/cookiePopUp/index';

const logoFont = require('../../assets/logo-font.png');
const loginTurtle = require('../../assets/Turtles/main-turtle.png');

const backgroundNative = require('../../assets/backgrounds/login_background.native.png');
const backgroundWeb = require('../../assets/backgrounds/login_background.web.png');

const styles = StyleSheet.create({
  background: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: '90%',
    alignItems: 'stretch',
    maxWidth: 400,
    backgroundColor: `rgba(255, 255, 255, 0.95)`,
    borderRadius: 60,
    zIndex: 999,
  },
  scrollViewContainer: {
    padding: 25,
  },
  logoFont: {
    alignSelf: 'center',
    width: '100%',
    height: 40,
    marginBottom: 15,
  },
  turtleTop: {
    width: '100%',
    height: 100,
  },
});

const Auth = ({ navigation }) => {
  const [{ mode, loginInfo }, setScreen] = useState({ mode: 'login', loginInfo: '' });

  const imageHeight = useRef(new Animated.Value(100)).current;
  const imageMargin = useRef(new Animated.Value(35)).current;

  useEffect(() => {
    if (mode === 'login') {
      Animated.parallel([
        Animated.timing(imageHeight, {
          duration: 200,
          toValue: 100,
          useNativeDriver: false,
        }),
        Animated.timing(imageMargin, {
          duration: 200,
          toValue: 35,
          useNativeDriver: false,
        }),
      ]).start();
    }

    if (mode === 'signUp') {
      Animated.parallel([
        Animated.timing(imageHeight, {
          duration: 200,
          toValue: 0,
          useNativeDriver: false,
        }),
        Animated.timing(imageMargin, {
          duration: 200,
          toValue: 0,
          useNativeDriver: false,
        }),
      ]).start();
    }
  }, [mode]);

  const navigateToMainApp = () => {
    navigation.navigate('App');
  };

  const navigateToDataDeclaration = () => {
    navigation.navigate('Data');
  };

  useEffect(() => {
    if (Platform.OS !== 'web') Haptics.selectionAsync();
  }, [mode]);

  return (
    <ImageBackground
      source={Platform.select({ native: backgroundNative, web: backgroundWeb })}
      style={styles.background}
      testID="background"
    >
      <KeyboardAvoidingView
        style={styles.card}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      >
        <ScrollView
          contentContainerStyle={styles.scrollViewContainer}
          keyboardShouldPersistTaps="handled"
          scrollEnabled={false}
        >
          <Image source={logoFont} style={styles.logoFont} resizeMode="contain" />
          <Animated.Image
            style={[
              styles.turtleTop,
              {
                marginBottom: imageMargin,
                height: imageHeight,
              },
            ]}
            source={loginTurtle}
            resizeMode="contain"
          />
          {mode === 'login' && (
            <>
              <LoginForm
                navigateToMainApp={navigateToMainApp}
                navigateToDataDeclaration={navigateToDataDeclaration}
                info={loginInfo}
                callback={() => {
                  setScreen({ mode: 'signUp', loginInfo: '' });
                }}
                testID="loginForm"
              />
            </>
          )}

          {mode === 'signUp' && (
            <SignUpForm
              callback={(newLoginInfo) => {
                setScreen({
                  mode: 'login',
                  loginInfo: newLoginInfo,
                });
              }}
              navigateToDataDeclaration={navigateToDataDeclaration}
              testID="signUpForm"
            />
          )}
        </ScrollView>
      </KeyboardAvoidingView>
      <CookiePopUp />
    </ImageBackground>
  );
};

export default Auth;
